import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import "./location.filter.css";
import axios from "axios";
import {
  fetchKeySearchLocation,
  searchLocation,
  fetchRegionSuggestionsInit,
  fetchKeySearchCompanyAndIndustries,
} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterCompany = (props) => {
  const dispatch = useDispatch();
  const { id, name } = useParams();
  const [companyValue, setCompanyValue] = useState([]);
  const [defaultValue, setDefaultValue] = useState();
  const Count = useSelector(
    (state) => state.searchSkillListingReducer.skillListingCount
  );
  const countLoading = useSelector(
    (state) => state.searchSkillListingReducer.countLoading
  );
  const totalCountError = useSelector(
    (state) => state.searchSkillListingReducer.error
  );
  const [searchtext, setSearch] = useState();
  const companies = useSelector(
    (state) => state.searchSkillListingReducer.companies
  );
  const [checkedItems, setCheckedItems] = useState([]);
  const [text, setText] = useState('');
  const companyCount = localStorage.getItem("companyCount");

  function removeDuplicatesByValue(data) {
    const uniqueValues = new Set();
    const filteredData = [];
  
    for (const obj of data) {
      if (!uniqueValues.has(obj.value)) {
        uniqueValues.add(obj.value);
        filteredData.push(obj);
      }
    }
  
    return filteredData;
  }

  
  useEffect(() => {
    if (props.check) {
      setDefaultValue(props.check);
    }
  }, [props]);

  useEffect(() => {
    var options = [];
    if (companies && companies?.result) {
      for (
        var i = 0;
        i < companies?.result?.orgDetails?.companies?.length;
        i++
      ) {
        options = [
          ...options,
          {
            value:
              companies?.result?.orgDetails?.companies?.[i]?._id?.trim(),
            count: companies?.result?.orgDetails?.companies?.[i]?.count,
          },
        ];
      }
      if (props?.check) {
        setCompanyValue(
          removeDuplicatesByValue([
            { value: props?.check, count: companyCount },
            ...options,
          ]).sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value.toLowerCase()))
        );
      } else {
        setCompanyValue(options.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value.toLowerCase())));
      }
    }
  }, [companies]);

  useEffect(() => {
    var options = [];
    if (companies?.length > 0) {
      for (
        var i = 0;
        i < companies?.result?.orgDetails?.companies?.length;
        i++
      ) {
        options = [
          ...options,
          {
            value:
              companies?.result?.orgDetails?.companies?.[i]?._id?.trim(),
            count: companies?.result?.orgDetails?.companies?.[i]?.count,
          },
        ];
      }
      if (props?.check) {
        setCompanyValue(
          removeDuplicatesByValue([
            { value: props?.check, count: companyCount },
            ...options,
          ]).sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value.toLowerCase()))
        );
      } else {
        setCompanyValue(options.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value.toLowerCase())));
      }
    }
  }, [companies]);

  const onChange = (e) => {
    e.preventDefault();
    localStorage.setItem("companyCount", e.target.value2);
    // let value = JSON.parse(e.target.value)

    props.setcheck(e.target.value);

    if (props.mobileFilter) {
      props.setVisible(false);
    }
  };

  const onLocationSearch = (value) => {
    props.setEmptyCompanyInput(value);
    let params = {}
    setText(value);
    if (Object.keys(props.searchLocationFilter).length) {
      const query = `company=${value}`;
      params = {
        value: query,
        body: props.searchLocationFilter,
      };
      // dispatch(fetchKeySearchCompanyAndIndustries(params));
    } else {
      const obj = {
        value: value,
        type: "company",
      };
      params = { obj };
    }
    dispatch(fetchKeySearchCompanyAndIndustries(params));
  };

  //    useEffect(()=>{
  //       if(props.emptyCompanyInput == '' && !props.searchLocationFilter){
  //          dispatch(fetchRegionSuggestionsInit());
  //       }
  //    },[props.emptyRegionInput])

  //    const getCheckedValues = (value2) => {
  //       if (props.checkRegionId?.includes(value2)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     };

  return (
    <div className="location-suggestion-view">
      <Input      
        onChange={(e) => onLocationSearch(e.target.value)}
        // onChange={debounce((e) => onLocationSearch(e.target.value))}
        className="filter-search-input"
        placeholder="Search"
        value={props.emptyCompanyInput}
        prefix={<SearchOutlined />}
      />
      <Radio.Group
        onChange={onChange}
        className="location-radios-grp radio-color"
        value={props?.check}
      >
        <Space direction="vertical" className={"infinite-scroller mobile-no-scroller"}
      style={{  overflow: "auto", width: "103%", paddingRight: "8px"}}>
          {!searchtext ? (
            <div
              className={`location-lists-container ${
                companyValue?.length > 5 ? "show-scrollbar" : ""
              }`}
            >
              {companyValue.map((items, index) => {
                return items?.value ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      marginTop: index == 0 ? "0px" : "10px",
                    }}
                    key={index}
                  >
                    <div
                      style={{
                        // display: "flex",
                        // justifyContent: "space-between",
                        width: "inherit",
                      }}
                    >
                      <Radio
                        type={"radio"}
                        key={index}
                        value={items.value}
                        value2={items?.count}
                        className="company-radio"
                        onChange={onChange}
                        checked={
                          props?.check
                            ? items?.value == props?.check
                            : items?.value == props?.check
                        }
                      >
                        <div style={{ display: "flex", justifyContent: 'space-between', width: 'inherit' }}>
                          <div>{items?.value} </div>
                          {/* {props?.fromCandMkt || id ? null : <> <div>({items?.count})</div> </>} */}
                        </div>
                      </Radio>
                      {/* <div>{items?.count}</div> */}
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          ) : (
            searchtext.map((items, index) => {
              return (
                <Radio
                  key={index}
                  value={defaultValue ? defaultValue : JSON.stringify(items)}
                  className="location-radio"
                  //  onChange={onChange}
                  // checked={items?.value == props?.regionObj}
                  checked={
                    props?.regionObj?.value
                      ? items?.value == props?.regionObj?.value
                      : items?.value == props?.regionObj
                  }
                >
                  <div style={{ display: "flex", justifyContent: 'space-between', backgroundColor: 'red' }}>
                    {items.value}
                    {/* {countLoading ? (
                      <LoadingOutlined className="count-loader" />
                    ) : Count?.result?.gigCount?.findIndex(
                        (e) => e.title === "Per Diem"
                      ) != -1 && Object.keys(totalCountError).length == 0 ? (
                      <div style={{ color: "#7e7e7e" }}>
                        (
                        {
                          Count?.result?.Companies[
                            Count?.result?.Companies?.findIndex(
                              (e) => e.title === items.value
                            )
                          ]?.count
                        }
                        )
                      </div>
                    ) : (
                      <div style={{ color: "#7e7e7e" }}>(0)</div>
                    )} */}
                  </div>
                </Radio>
              );
            })
          )}
        </Space>
      </Radio.Group>  
    </div>
  );
};
export default FilterCompany;
